import { createUseStyles } from 'react-jss';
export default createUseStyles((theme) => ({
    container: {
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: '0px 16px 24px #00000033',
        width: 156,
        position: 'absolute',
        top: -92,
        left: 100,
        overflowX: 'hidden',
        overflowY: 'auto'
    },
    item: {
        padding: '1rem 1.5rem',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.regular,
            cursor: 'pointer'
        }
    }
}));
//# sourceMappingURL=styles.js.map